import { Form, InputNumber, Modal, Select } from "antd";
import { useEffect } from "react";
import { errorMsg, successMsg } from "../../../Utils/Utils";
import { toTransfertApi } from "../Api";

const StockTransfert = ({ article, emplacements, close }) => {
  const [form] = Form.useForm();
  useEffect(() => {}, []);

  const toTransfertStock = () => {
    form.validateFields().then((res) => {
      const quantity = res.qte;
      console.log({ res });
      const empDest = res.empDest;
      const empSource = res.empSource;

      toTransfertApi([
        {
          id: article.id,
          empSource,
          empDest,
          quantity,
        },
      ]).then((res) => {
        if (res.error) {
          errorMsg(
            "Stock insuffisant pour les articles suivants \r\n " +
              res.list.join("\r\n")
          );
        } else {
          close();
          successMsg(res.msg);
        }
      });
    });
  };
  return (
    <Modal
      visible={true}
      onCancel={() => close()}
      onOk={() => toTransfertStock()}
    >
      <div>
        <h3>{article?.titre2}</h3>
      </div>
      <Form form={form}>
        <Form.Item
          label="Emplacement Source"
          name="empSource"
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
        >
          <Select
            showSearch
            style={{ width: "100%" }}
            defaultValue="0"
            filterOption={(input, option) =>
              option?.value
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            onSearch={(e) => console.log(e)}
          >
            {article?.emplacement.map((e, i) => (
              <Select.Option value={e.emp} key={i}>
                {e.emp}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
          label="Emplacement Destination"
          name="empDest"
        >
          <Select
            showSearch
            style={{ width: "100%" }}
            defaultValue="0"
            filterOption={(input, option) =>
              option?.value
                ?.toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            onSearch={(e) => console.log(e)}
          >
            {emplacements.map((e, i) => (
              <Select.Option value={e.title} key={i}>
                {e.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
          name="qte"
          label="Quantité"
        >
          <InputNumber />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StockTransfert;
